import { Box, Grid } from '@chakra-ui/react';
import { FC } from 'react';

type Props = {
  /** カラム幅 */
  templateColumns: string;
  /** 行クリックイベントのハンドラ */
  onClick: () => void;
  /** 行の中身 */
  children: React.ReactNode;
};

export const ListRow: FC<Props> = ({ templateColumns, onClick, children }) => (
  <Box
    as="button"
    m={0}
    h="auto"
    w="100%"
    pl="16px"
    pt={3}
    pb={3}
    textAlign="start"
    border="none"
    backgroundColor="primaryList.item.bgColor"
    color="primaryList.item.color"
    cursor="pointer"
    _hover={{
      background: 'gray.100',
    }}
    _active={{
      background: 'gray.200',
    }}
    borderBottom="1px"
    borderBottomColor="primaryList.item.borderColor"
    onClick={onClick}
  >
    <Grid
      templateColumns={templateColumns}
      gap="10px"
      justifyItems="start"
      alignItems="center"
    >
      {children}
    </Grid>
  </Box>
);
